import { getLogger } from '@kit/logger';

import { AnalyticsService } from './types';

const noop = (event: string) => {
  // do nothing - this is to prevent errors when the analytics service is not initialized

  return async (...args: unknown[]) => {
    void getLogger().then((logger) =>
      logger.debug(
        {
          service: 'analytics',
          function: 'noop',
          event,
          argsCount: args.filter(Boolean).length,
        },
        `Noop analytics service called with event: ${event}`,
      ),
    );
  };
};

/**
 * Null analytics service that does nothing. It is initialized with a noop function. This is useful for testing or when
 * the user is calling analytics methods before the analytics service is initialized.
 */
export const NullAnalyticsService: AnalyticsService = {
  initialize: noop('initialize'),
  trackPageView: noop('trackPageView'),
  trackEvent: noop('trackEvent'),
  identify: noop('identify'),
};
